// @ts-ignore
import { /*loader,*/ gql } from "graphql.macro";

const deleteDashboard = gql`
  mutation deleteDashboard($where: DashboardWhereUniqueInput!) {
    deleteDashboard(where: $where)
      @rest(
        type: "Dashboard"
        path: "dashboard/{args.where.id}"
        method: "DELETE"
      ) {
      id
    }
  }
`;

export default deleteDashboard;
